const liff = {
    error: '',
    ready: true,
    init: async () => {},
    openWindow: async () => {},
    closeWindow: async () => {},
    shareTargetPicker: () => new Promise((resolve) => setTimeout(() => resolve({ status: 'success' }), 1000)),
    getDecodedIDToken: () => ({ phone_number: '0912345678' }),
    isLoggedIn: () => true,
    isInClient: () => true,
    getFriendship: async () => ({ friendFlag: true }),
    getProfile: async () => ({
        userId: 'Uc4026efa1f37cef9bf846079c83ccdcc', // U + 32 numbers
        displayName: 'Ted',
        // statusMessage: 'Test test',
        pictureUrl:
            'https://profile.line-scdn.net/0hBRRqA8ggHX1_CDYoGS9jAg9YHhdceURvUTxbTxoMEE1CbwosBztbTBpdEE9EMQ0iUGZQEhkOQE9zG2obYV7hSXg4Q0pGPV0uW2ZWmQ'
    }),
    getAccessToken: () =>
        'eyJhbGciOiJIUzI1NiJ9.w1rRhj5G9UUC3lwRqr21FnNNYiFwsajXa5lzNSfcKDwfltosm7773FFxjGk8mM-Kz3d4UaIKytJpX-0MGyqWnblxKNYV6cJPDDQlJPrUUOmiaR4_mX3gB4Jp4ft3fxqLYhgw7G9YpJyuJQOg92GSTxcyUuweuKiHjwGJIdozhtM.7ivwGpasLagNPz95P37YU-iJJvAXjVhe4VWFkh4HQgE'
};

export default liff;
